<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo
        :titulo="locale[local].screen.inclusaoPonto.string001"
      />
      <v-divider />

      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="primary"
              class="white--text"
              small
              @click="dialog = true"
            >
              <span> Incluir Marcação </span>
              <v-icon right medium> mdi-plus </v-icon>
            </v-btn>
          </template>
        </v-dialog>
      </v-toolbar>

      <div class="ma-5">
        <v-card outlined elevation="0">
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              :items-per-page="10"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </v-content>

    <v-card>
      <v-card-text>
        <v-overlay v-model="carregando">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card-text>
    </v-card>

    <v-dialog width="640px" v-model="dialog" scrollable persistent>
      <v-form ref="form">
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar color="primary" class="white--text">
              Solicitação de Ajuste de Ponto
            </v-toolbar>
          </v-card-title>

          <v-card-text class="pt-8">
            <v-row>
              <v-col lg="6">
                <cgi-date-picker
                  :regras="[(v) => !!v || 'Preencha o campo']"
                  compacto
                  nome="Data"
                  v-model="ttPonto.dtMovto"
                >
                </cgi-date-picker>
              </v-col>
              <v-col lg="6">
                <cgi-time-picker
                  :regras="[(v) => !!v || 'Preencha o campo']"
                  v-model="ttPonto.segMovto"
                  nome="Hora"
                  compacto
                ></cgi-time-picker>
              </v-col>
            </v-row>

            <v-textarea
              v-model="ttPonto.observacao"
              label="Observação"
              required
              dense
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="red" small @click="dialog = false">
              <v-icon right medium> mdi-close</v-icon>
              <span> Cancelar </span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="white--text" small @click="salvar()">
              <v-icon right medium> mdi-content-save </v-icon>
              <span> Salvar </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-app>
</template>

<script>
import Service from "../components/api/Service";
import moment from "moment";
import { snackbar } from "cids-cgi/lib/util";

export default {
  data: () => ({
    snackbar: false,
    loading: false,
    dialog: false,
    headers: [
      {
        text: "Empresa",
        value: "codEmp",
        divider: true,
      },
      {
        text: "Empregado",
        value: "codEmpregado",
        divider: true,
      },
      {
        text: "Nome",
        value: "nome",
        divider: true,
      },
      {
        text: "Data",
        value: "dtMovto",
        divider: true,
      },
      {
        text: "Hora",
        value: "segMovto",
        divider: true,
      },
      {
        text: "Observaçao",
        value: "observacao",
        divider: true,
      },
    ],
    items: [],
    carregando: false,
    ttPonto: {
      dtMovto: null,
      segMovto: null,
      observacao: "",
    },
  }),
  async mounted() {},
  created() {
    moment.locale("pt-br");
    this.buscarMarcacaoAjuste();
  },
  methods: {
    async redirecionar() {
      try {
        this.loading = true;
        
      } finally {
        this.loading = false;
      }
    },

    async buscarMarcacaoAjuste() {
      this.loading = true;
      this.carregando = true;

      try {
        const service = new Service();
        this.items = await service.buscarMarcacaoAjuste();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      } finally {
        this.carregando = false;
      }
    },
    async salvar() {
      this.loading = true;
      this.carregando = true;

      if (this.$refs.form.validate()) {
        const service = new Service();
        const retorno = await service.salvaAjusteMarcacao(this.ttPonto);

        if (retorno[0].estatus === "Sucesso") {
          snackbar.show({
            message: retorno[0].msgErro.split(" - ")[1],
            color: "green",
            timeout: 3000,
          });

          this.buscarMarcacaoAjuste();
        } else {
          snackbar.show({
            message: retorno[0].msgErro.split(" - ")[1],
            color: "red",
            timeout: 3000,
          });
        }
      } else {
        this.loading = false;
        this.carregando = false;
        return;
      }

      this.dialog = false;
      this.loading = false;
      this.carregando = false;

      this.ttPonto.dtMovto = null;
      this.ttPonto.segMovto = null;
      this.ttPonto.observacao = "";
    },
  },
};
</script>
